import { logWrapper } from '../../utils';

export default {
  publicLinkService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    function (runtimeConstant, $http, $q, $filter, webApiSettings) {
      'use strict';

      function handleError(err, status) {
        if (status === 404) {
          var error = {
            error: $filter('translate')('ERROR'),
            error_description: $filter('translate')('REVISION NOT FOUND'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function getPublicLink(idRevision) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/publicLink/' +
              idRevision,
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function (result) {
              var data = result.data;
              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function postPublicLinkShortDateExpiration(idRevision, PublicLinkDate) {
        var deferred = $q.defer();

        var url = 'revisions/publicLink/' + idRevision;
        $http
          .post(webApiSettings.apiServiceBaseUri + url, PublicLinkDate, {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function cancelPublicLink(idRevision, linkOrigin, shortLink) {
        var deferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'revisions/cancelPublicLink/' + idRevision,
            { IsPublic: false, OriginLink: linkOrigin, ShortLink: shortLink },
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function (result) {
              var data = result.data;
              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );
        return deferred.promise;
      }

      function getPublicLinkShort(idRevision, urlBase) {
        var deferred = $q.defer();

        if (webApiSettings.detailsCompany === 'abase') {
          var url = 'revisions/publicLink/' + idRevision;

          $http
            .get(webApiSettings.apiServiceBaseUri + url, {
              ignoreLoadingBar: true,
            })
            .then(
              function (result) {
                var data = result.data;
                deferred.resolve(data);
              },
              function (err) {
                var error = handleError(err.data, err.status);
                deferred.reject(error);
              }
            );
        } else {
          var lnkBase = btoa(urlBase)  // Converte para Base64
            .replace(/\+/g, '-') // Substitui "+" por "-"
            .replace(/\//g, '_') // Substitui "/" por "_"
            .replace(/=+$/, ''); // Remove "=" do final

          var url = webApiSettings.apiServiceBaseUri + 'revisions/publicLinkShort/' + idRevision + '/' + lnkBase;

          $http
            .get(url, {
              ignoreLoadingBar: true
            })
            .then(
              function (result) {
                var data = result.data;
                deferred.resolve(data);
              },
              function (err) {
                var error = _handleError(err.data, err.status);
                deferred.reject(error);
              }
            );
        }

        return deferred.promise;
      }

      function getLinkShort (originLink) {
        var deferred = $q.defer();

        var lnkBase = btoa(originLink)  // Converte para Base64
          .replace(/\+/g, '-') // Substitui "+" por "-"
          .replace(/\//g, '_') // Substitui "/" por "_"
          .replace(/=+$/, ''); // Remove "=" do final

        var url = webApiSettings.apiServiceBaseUri + 'revisions/linkShort/' + lnkBase;

        $http
          .get(url, {
            ignoreLoadingBar: true
          })
          .then(
            function (result) {
              var data = result.data;
              deferred.resolve(data);
            },
            function (err) {
              var error = _handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          var publicLinkServiceFactory = {};

          publicLinkServiceFactory.getPublicLink = logWrapper(
            getPublicLink,
            runtimeConstant.isDebugServicesInternals
          );
          publicLinkServiceFactory.cancelPublicLink = logWrapper(
            cancelPublicLink,
            runtimeConstant.isDebugServicesInternals
          );
          publicLinkServiceFactory.postPublicLinkShortDateExpiration = logWrapper(
            postPublicLinkShortDateExpiration,
            runtimeConstant.isDebugServicesInternals
          );

          publicLinkServiceFactory.getPublicLinkShort = logWrapper(
            getPublicLinkShort,
            runtimeConstant.isDebugServicesInternals
          );

          publicLinkServiceFactory.getLinkShort = logWrapper(
            getLinkShort,
            runtimeConstant.isDebugServicesInternals
          );

          return publicLinkServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
